import * as React from 'react'
import { getGroupName } from '@disco/utils/groups'
import CustomDropdown from 'components/ui/dropdowns/custom-dropdown'
import type { Group } from 'types/group'

type Props = {
  autoFocus?: boolean
  placeholder?: string
  channels?: Group[]
  channelsIndexed?: (...args: Array<any>) => any
  selectedChannels?: Array<Record<string, any>>
  onChannelSelect: (...args: Array<any>) => any
  clearable?: boolean
  disabled?: boolean
  scrollContainer?: HTMLDivElement | null | undefined
  enableUp?: boolean
}

/**
 * Channel/group selector dropdown component with multi-selection support
 * Allows users to select multiple channels from available groups
 */
export const ChannelSelector = ({
  autoFocus,
  channels,
  channelsIndexed,
  selectedChannels,
  onChannelSelect,
  clearable = true,
  disabled,
  scrollContainer,
  enableUp,
  placeholder,
}: Props) => {
  const options = React.useMemo(
    () =>
      (channels ?? []).map(channel => ({
        value: channel.id,
        label: getGroupName(channel),
      })),
    [channels],
  )

  return (
    <CustomDropdown
      autoFocus={autoFocus}
      options={options}
      optionsIndexed={channelsIndexed}
      multi
      truncateDisplayedOptions={100} // Temporarily disabled
      // clearable={clearable}
      value={selectedChannels}
      placeholder={placeholder}
      onChange={onChannelSelect}
      disabled={disabled}
      scrollContainer={scrollContainer}
      enableUp={enableUp}
    />
  )
}

export default ChannelSelector
